import { mapGetters, mapActions } from 'vuex'

import LazyImage from '@/components/LazyImage/index'
import ResponseDialog from '@/components/ResponseDialog'

export default {
  name: 'table-list',
  components: {
    LazyImage,
    ResponseDialog
  },
  data: () => ({
    userMenu: false,
    userLink: '',
    x: 0,
    y: 0,
    clickedUserId: null,
    isMe: false,
    removeUserResponseDialog: false,
    removeUserResponseDialogText:
      'Are you sure you want to remove this user from the group?',
    adminResponseDialog: false,
    adminResponseDialogText: '',
    backendResponseDialog: false,
    backendResponseDialogText: '',
    userRole: {
      text: '',
      callback: null,
      action: ''
    }
  }),
  props: {
    header: Array,
    body: Array,
    selectedId: Number,
    hasHeaderBorder: {
      type: Boolean,
      default: false
    },
    showRankStatus: {
      type: Boolean,
      default: false
    },
    showPointsThisWeek: {
      type: Boolean,
      default: true
    },
    noDataMessage: {
      type: String,
      default: 'No available data'
    },
    globalGroupRanking: {
      type: Boolean,
      default: false
    },
    showUserPredictionDropdown: {
      type: Boolean,
      default: false
    },
    groupTable: {
      type: Object,
      default: () => ({
        showRemove: false,
        admin: false,
        groupId: null,
        groupRoles: null,
        adminId: null
      })
    }
  },
  computed: {
    ...mapGetters('player', {
      removeUserResponse: 'GET_REMOVE_PLAYER_FROM_GROUP',
      makeAdminResponse: 'GET_MAKE_AS_GROUP_ADMIN',
      removeAdminResponse: 'GET_REMOVE_AS_GROUP_ADMIN'
    })
  },
  methods: {
    ...mapActions('player', {
      removeUserRequest: 'REMOVE_PLAYER_FROM_GROUP',
      makeAdminRequest: 'MAKE_AS_GROUP_ADMIN',
      removeAdminRequest: 'REMOVE_AS_GROUP_ADMIN'
    }),
    getAvatar(avatar) {
      return avatar || require('@/assets/default-avatar.svg')
    },
    isPositive(number) {
      if (typeof number === 'number') {
        return number > 0
      }
    },
    isZero(number) {
      if (typeof number === 'number' && number === 0) {
        return true
      }
    },
    assignWidth(index) {
      if (index === 1) {
        return this.showPointsThisWeek ? '30%' : '65%'
      }

      if (index === 2) {
        return this.showPointsThisWeek ? '15%' : 'inherit'
      }

      if (index === 3) {
        return this.globalGroupRanking ? '25%' : '20%'
      }

      if (index === 4) {
        return this.showPointsThisWeek ? '20%' : 'inherit'
      }

      return 'inherit'
    },
    userMenuClicked(userId, e, isMe) {
      e.stopPropagation()
      if (this.groupTable.admin) {
        const userRole = this.groupTable.groupRoles.find(
          user => user.userId === userId
        )
        if (userRole.roleId === this.groupTable.adminId) {
          this.userRole.action = 'removeAdmin'
          this.userRole.text = 'Remove group admin'
          this.userRole.callback = () => {
            return this.showResponseDialog('removeAdmin')
          }
        } else {
          this.userRole.action = 'makeAdmin'
          this.userRole.text = 'Make group admin'
          this.userRole.callback = () => {
            return this.showResponseDialog('makeAdmin')
          }
        }
      }
      this.x = e.clientX - 50
      this.y = e.clientY + 10
      this.userMenu = true

      this.userLink = `/user-prediction/${userId}`
      this.clickedUserId = userId
      this.isMe = isMe
    },
    removeUserResponseDialogButtonClick() {
      const payload = {
        userId: this.clickedUserId,
        groupId: this.groupTable.groupId
      }

      this.removeUserRequest(payload).then(() => {
        this.closeRemoveUserResponseDialog()
        const { message } = this.removeUserResponse
        this.backendResponseDialogText = message
        this.backendResponseDialog = true
      })
    },
    adminResponseDialogButtonClick() {
      if (this.userRole.action === 'makeAdmin') {
        const payload = {
          newAdmin: this.clickedUserId,
          groupId: this.groupTable.groupId
        }
        this.makeAdminRequest(payload).then(() => {
          this.closeAdminResponseDialog()
          const { message } = this.makeAdminResponse
          this.backendResponseDialogText = message
          this.backendResponseDialog = true
        })
      } else if (this.userRole.action === 'removeAdmin') {
        const payload = {
          userId: this.clickedUserId,
          groupId: this.groupTable.groupId
        }
        this.removeAdminRequest(payload).then(() => {
          this.closeAdminResponseDialog()
          const { message } = this.removeAdminResponse
          this.backendResponseDialogText = message
          this.backendResponseDialog = true
        })
      }
    },
    backendResponseDialogButtonClick() {
      this.$router.go()
    },
    closeRemoveUserResponseDialog() {
      this.removeUserResponseDialog = false
    },
    closeAdminResponseDialog() {
      this.adminResponseDialog = false
    },
    showResponseDialog(dialog) {
      if (dialog === 'removeUser') {
        this.removeUserResponseDialog = true
      } else if (dialog === 'makeAdmin') {
        this.adminResponseDialogText =
          'Are you sure you want to give admin privileges to this user?'
        this.adminResponseDialog = true
      } else if (dialog === 'removeAdmin') {
        this.adminResponseDialogText =
          'Are you sure you want to remove admin privileges to this user?'
        this.adminResponseDialog = true
      }
    },
    isAdminOfGroup(userId) {
      if (this.groupTable.groupRoles) {
        const userRole = this.groupTable.groupRoles.find(
          user => user.userId === userId
        )
        if (userRole.roleId === this.groupTable.adminId) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    goToPredictions(link) {
      if (this.isMe) {
        this.$router.push({ path: '/app/dashboard/result' })
      } else {
        this.$router.push({ path: link })
      }
    }
  }
}
